import React from "react";
import { FormResult } from "../../../types/TeamForm";
import "./FixtureTile.scss";

interface TeamFormChipsProps {
  form: FormResult[];
  align: "left" | "right" | "center";
}

const RESULT_LABEL: Record<FormResult, string> = {
  W: "Win",
  D: "Draw",
  L: "Loss",
};

// Compact W/D/L form strip for a team, oldest → newest. Shared by the mobile
// and desktop fixture cards. Shows a muted note before the team has any played
// matches in the tournament.
const TeamFormChips: React.FC<TeamFormChipsProps> = ({ form, align }) => {
  if (form.length === 0) {
    return <span className="teamForm__empty">No games yet</span>;
  }

  return (
    <span className={`teamForm teamForm--${align}`}>
      {form.map((result, index) => (
        <span
          key={`form-${index}`}
          className={`teamFormChip teamFormChip--${result}`}
          title={RESULT_LABEL[result]}
        >
          {result}
        </span>
      ))}
    </span>
  );
};

export default TeamFormChips;
